import React, { useState, useEffect } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Swal from 'sweetalert2';
import { Card, CardBody, CardTitle, Breadcrumb, BreadcrumbItem, Row, Col } from 'reactstrap';

//Componentes
import Loading from '../../components/modales/loadingModal';
import ListadoAPE from '../../components/lists/ListadoAPE';
import LoadingModalTransparent from '../../components/modales/loadingModalTransparent';

//Redux
import { connect } from 'react-redux';

//Funciones
import { userRolValidation } from '../../utils/userValidation/rolValidation'
//GCP Functions
import { functionsHttpsCallable } from '../../utils/FirebaseStorage/firebase';

//API Calls
const listadoSolicitudes = functionsHttpsCallable('ape_listadoSolicitudesCargaContrato');
const estadoEmpresa = functionsHttpsCallable('ape_getEstadoEmpresa');

const mapStateToProps = state => ({
    usuarioActivo: state
})

//Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const GestorCargaContrato = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [campoBusqueda, setCampoBusqueda] = useState('');
    const [campo, setCampo] = useState('');
    const [userId, setUserId] = useState(parseInt(userData.userId));
    const [listaSolicitudes, setListaSolicitudes] = useState([]);
    const [dataEmpresa, setDataEmpresa] = useState(undefined);
    const [listaSolicitudesFilter, setListaSolicitudesFilter] = useState([]);
    const [solicitudActiva, setSolicitudActiva] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getDataSolicitudes();
        getDataEmpresa();
        document.title = "Cargar Contrato Firmado";
    }, [])

    useEffect(() => {
        handleBusqueda()
    }, [campoBusqueda])
    
    useEffect(() => {
        if (dataEmpresa && !dataEmpresa.cargueContratoHabilitado) {
            Swal.fire({
                title: "Cargue de contrato bloqueado",
                text: "El cargue de contratos se encuentra deshabilitado. Contacte al administrador de la herramienta.",
                icon: "error"
            })
        }
    }, [dataEmpresa])

    const getDataSolicitudes = async () => {
        try {
            let body = {
                userId: userId,
                cod_empr: parseInt(userData.codigoEmpresa)
            }
            let dataSolicitudes = await listadoSolicitudes(body)
            setListaSolicitudes(formatListado(dataSolicitudes.data.data))
            setListaSolicitudesFilter(formatListado(dataSolicitudes.data.data))
            setLoading(false)
        }
        catch (e) {
            console.log('error', e)
        }
    }

    const getDataEmpresa = async () => {
        try {
            let body = {
                cod_empr: parseInt(userData.codigoEmpresa)
            }
            let dataEmpresa = await estadoEmpresa(body);
            if (dataEmpresa.data.data) setDataEmpresa(dataEmpresa.data.data)
            setLoading(false)
        }
        catch (e) {
            console.log('error', e)
        }
    }

    const formatListado = (listado) => {
        const newList = [];
        listado.forEach((item) => {
            newList.push({ id: item.solicitudId,
                cargo: item.codigoCargo,
                color: 'info',
                estado: item.estadoAPE,
                campo: item.campo,
                creador: item.cedulaCreador,
                responsable: item.codigoActual,
                cliente: item.clienteComercial,
                name: item.nombreReclutador })
        })
        return newList
    }

    const handleBusqueda = () =>{
        let solicitudesPropiasTemp
        if (campoBusqueda !== '' && campoBusqueda !== undefined) {
            if (campo === 'cargo' || campo === 'id' ) {
                if (listaSolicitudes.length > 0){
                    solicitudesPropiasTemp = listaSolicitudes.filter(solicitud => solicitud[campo].toString().includes(campoBusqueda.toUpperCase()))
                }
            }
            else {
                solicitudesPropiasTemp = listaSolicitudes
            }
        }
        else {
            solicitudesPropiasTemp = listaSolicitudes
        }
        setListaSolicitudesFilter(solicitudesPropiasTemp)
    }

    const renderListaSolicitudes = () => {
        return (
            <ListadoAPE
                disabled={dataEmpresa ? !dataEmpresa.cargueContratoHabilitado : true}
                // disabled={true}
                listaSolicitudes={listaSolicitudesFilter}
                linkTo={'/home/cargarContrato/?ape='}
                proceso={'reclutamiento'}
                enableButton={userData.roles.includes('reclutador') || userData.roles.includes('administrador')}
                />
        )

    }

    return (loading ?
        <div className={"loading-area"}>
            <Loading />
        </div> :
        <>
            <Toaster />
            <Breadcrumb>
                <BreadcrumbItem className='breadcum-display-content' active>
                    Solicitudes pendientes por cargar contrato
                </BreadcrumbItem>
            </Breadcrumb>
            <Card>
                <CardBody>
                    <CardTitle tag="h5">Solicitudes</CardTitle>
                </CardBody>
                <CardBody>
                    <Row>
                        <Col lg='10' md='8' xs="12">
                            <TextField
                                required
                                autoComplete='off'
                                key={`key_busqueda`}
                                id={`input_busqueda`}
                                fullWidth
                                label={'Busqueda'}
                                onChange={(e) => setCampoBusqueda(e.target.value)}
                                defaultValue=""
                                margin="normal"
                            />
                        </Col>
                        <Col lg='2' md='4' xs="12">
                            <Autocomplete
                                required
                                margin="dense"
                                options={[{ label: 'Numero APE', value: 'id' }, { label: 'Cargo', value: 'cargo' }]}
                                key={`key_Cargo`}
                                id={`select_Cargo`}
                                onChange={(event, newValue) => {
                                    if (newValue) { setCampo(newValue.value) }
                                    else {
                                        setCampo(undefined)
                                        setListaSolicitudesFilter([...listaSolicitudes])
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label={'Campo'} margin="normal" />
                                )}
                                getOptionLabel={(option) => option.label}
                                renderOption={(option) => (
                                    <React.Fragment>
                                        {option.label}
                                    </React.Fragment>
                                )}
                            />
                        </Col>
                    </Row>
                    {renderListaSolicitudes()}
                </CardBody>
            </Card>
        </>
    )
}

export default withAuthenticationRequired(connect(mapStateToProps)(GestorCargaContrato), {
    onRedirecting: () => <Loading />,
  });